import React, { useState, useEffect, useRef, useMemo } from "react"
import { Link } from 'gatsby'
import SanityImage from "gatsby-plugin-sanity-image";
import { throttle } from "../../helpers/littleHelpers"

import emblem from '../../images/emblem.svg'

const FirstScreen = (props) => {
    const [emblemStyle, setEmblemStyle] = useState({});
    const [frontImageClass, setFrontImageClass] = useState("objectFrontImg");
    const touchStartX = useRef(Infinity);
    const wrapperRef = useRef(null);
    const frontImageRef = useRef(null);
    const frontImageReady = useRef(false);
    const frontImageMaxVector = useRef(undefined);
    const rem = useRef(undefined);
    const lastInnerWidth = useRef(undefined);
    const sanityImageWidthSetting = useRef(1400);
    
    useEffect(() => {
        calculateFirstScreenSizes();
        ensureFrontImagePosition();
        rem.current = parseFloat(getComputedStyle(document.documentElement).fontSize);
        lastInnerWidth.current = window.innerWidth;
        window.addEventListener('resize', throttledResizeHandler);

        if (window.innerWidth > sanityImageWidthSetting.current * 2) {
            sanityImageWidthSetting.current = window.innerWidth / 2;
        }
        
    }, [])

    const calculateFirstScreenSizes = () => {
        let headingContainerObject = document.getElementsByClassName("headingContainer")[0];

        let headingFontSize = Number.parseFloat(window.getComputedStyle(headingContainerObject)["font-size"]);
        let headingContainerHeight = headingContainerObject.offsetHeight;
        let headingHeight = headingContainerObject.firstChild.offsetHeight;
        let emblemHeight = Math.round(headingContainerObject.offsetHeight / 1.618 / 2);
        let emblemPaddingTop = emblemHeight / 1.618;
        let emblemPaddingBottom = 0;
        
        if (headingContainerHeight - headingHeight < headingFontSize * 2) {
            emblemPaddingBottom = emblemPaddingTop;
            setFrontImageClass("objectFrontImg tight");
        }
        
        if (document.getElementsByClassName("objectName")[0].offsetTop - emblemHeight < emblemHeight) {
            setEmblemStyle({ ...emblemStyle, "height":`${emblemHeight}px`, "paddingTop":`${emblemPaddingTop}px`, "paddingBottom":`${emblemPaddingBottom}px` })
        } else {
            setEmblemStyle({ ...emblemStyle, "height":`${emblemHeight}px`, "paddingTop":`${emblemPaddingTop}px` })
        }
    }
    
    const ensureFrontImagePosition = () => {

        if (frontImageRef.current !== null) {

            if (frontImageRef.current.offsetWidth >= wrapperRef.current.offsetWidth) {
            
                frontImageRef.current.style.transform = `translateX(-15%)`

                window.setTimeout(() => {
                    frontImageRef.current.style.transition = "none"
                    frontImageReady.current = true;
                }, 1300)
                
            } else {

                touchStartX.current = Infinity
                frontImageRef.current.style.transform = "translateX(0)"

                return
            }

        } else {
            // SanityImage is loading and showing placeholder 
            // with data-lqip="true"
            if (wrapperRef.current.children[0].getAttribute("data-lqip")) {
                window.setTimeout(() => {ensureFrontImagePosition()}, 400)
            } else if (wrapperRef.current !== null) {
                frontImageRef.current = wrapperRef.current.children[0];
                ensureFrontImagePosition();
            } else {
                return
            }

        }
    }

    const throttledResizeHandler  = useMemo(
        () => throttle(() => {

            if (document.getElementById("firstScreen")) {

                if (lastInnerWidth.current !== window.innerWidth) {

                    if (wrapperRef.current === null) {
                        window.removeEventListener('resize', throttledResizeHandler);
                        return
                        // this debugs memory leak when user with event handler visit page
                        // with different "throttledResizeHandler" and former refs are null at the moment
                    }

                    frontImageReady.current = false;
                    calculateFirstScreenSizes();
                    ensureFrontImagePosition();
                    lastInnerWidth.current = window.innerWidth;
                }
            } else {
                window.removeEventListener('resize', throttledResizeHandler);
            }
        }, 1000), 
    [emblemStyle, frontImageClass]);

    const handleTouchStart = (e) => {

        if (frontImageReady.current !== true) {
            return
        } else {
            frontImageMaxVector.current = e.target.offsetWidth * 0.15 + rem.current * 2;
            touchStartX.current = e.touches[0].pageX;
        }

    }

    const handleTouchMove = (e) => {

        if (touchStartX.current !== Infinity) {
            let vector = e.touches[0].pageX - touchStartX.current;

            if (Math.abs(vector) >= frontImageMaxVector.current) {
                let direction = Math.sign(vector);
                vector = frontImageMaxVector.current * direction;
            }

            e.target.classList.remove("released")
            e.target.style.transform = `translateX(calc(-15% + ${vector}px))`;

        } else {
            return  
        }
    }

    const handleTouchEnd = (e) => {

        if (touchStartX.current !== Infinity && frontImageReady.current === true ) {
            e.target.classList.add("released")
            e.target.style.transform = `translateX(-15%)`
        }

    }

    return (
        <div id="firstScreen">
            <Link id="linkToMain" to="/" onClick={()=> { window.removeEventListener('resize', throttledResizeHandler) } } >
                <img id='emblem' src={emblem} alt='Эмблема территории «Ландшафт»' style={emblemStyle} />
            </Link>
            <div className="headingContainer x-hight-align-container">
                <h1 className="objectName x-height-line">{props.name}</h1>
            </div>
            <div className="frontImageWrapper" ref={wrapperRef} >
                <SanityImage
                    {...props.image}
                    className={frontImageClass}
                    alt={props.name}
                    width={sanityImageWidthSetting.current}
                    style={{
                        aspectRatio: `${props.image.asset.metadata.dimensions.aspectRatio}`
                    }}
                    loading={"eager"}
                    config={{
                        quality: 85,
                        fit: "min",
                        auto: "format",
                        crop: "entropy"
                    }}
                    onTouchStart={handleTouchStart}
                    onTouchMove={handleTouchMove}
                    onTouchEnd={handleTouchEnd} 
                ></SanityImage>
                <div className="frontImageBorder"></div>
            </div>
        </div>
    );
}

export default FirstScreen;